import { SystemService } from "./SystemService";

class AuthService {
    systemService = null;
    api = null;

    availableConfigs = [
        {
            company: '001',
            name: 'Λατομείο Βώλακα',
            whCode: '4',
            products: [
                {
                    code: '0036998',
                    name: 'Όγκος Βώλακα',
                    assessments: [
                        'A',
                        'AB',
                        'B',
                        'BR',
                        "C"
                    ]
                },
                {
                    code: '0040592',
                    name: 'Ξωφάρι Βώλακα',
                    assessments: [
                        'K',
                        'Ξ'
                    ]
                }
            ],
            shelves: [
                'Π12',
                'Π14',
                'Στοά Λυδία (Μέτωπο)',
                'Στοά Λυδία (Δεξιά)',
                'Στοά Λυδία (Αριστερά)',
                'Στοά Β2 (Δεξιά)',
                'Στοά Β3  (Δεξιά)',
                'Στοά Γ',
                'Στοά Γ Ράμπα',
                'ΠΑΤΑΡΙ 19',
                '2021',
                'Π13',
                'Π15'
            ]
        },
        {
            company: '001',
            name: 'Μαλακάσα',
            whCode: '2',
            products: [
            ],
            shelves: [
            ]
        },
        {
            company: '003',
            name: 'Λατομείο Καβάλας',
            whCode: '49',
            ordersWhCode: '41',
            products: [
                {
                    code: '4000001', name: 'ΟΓΚΟΣ ΗΜΙΛΕΥΚΟ ΣΤΕΝΩΠΟΥ', assessments: ['C1',
                        'C2',
                        'C3',
                        'CL1',
                        'CL2',
                        'CL3']
                },
                {
                    code: '4000009', name: 'ΞΟΦΑΡΙ ΗΜΙΛΕΥΚΟ ΣΤΕΝΩΠΟΥ', assessments: [
                        'CLΞ',
                        'CΞ'
                    ]
                }
            ],
            shelves: [
                'Λατομείο Καβάλας'
            ]
        },
        {
            company: '003',
            name: 'Λατομείο Γρανίτη',
            whCode: '29',
            ordersWhCode: '21',
            products: [
                {
                    code: '2000001', name: 'ΓΡΑΝΙΤΗΣ ΚΥΚΝΟΣ', assessments: [
                        'K1',
                        'K2',
                        'K2-3',
                        'K3',
                        'K4'
                    ]
                },
                {
                    code: '2000002', name: 'ΓΡΑΝΙΤΗΣ VICTORY', assessments: [
                        'V1',
                        'V2',
                        'V2-3',
                        'VL',
                        'V3'
                    ]
                },
                {
                    code: '2000003', name: 'ΓΡΑΝΙΤΗΣ NORD BLANC', assessments: [
                        'NB1',
                        'NB2',
                        'NB3',
                        'NB4',
                        'NB5'
                    ]
                },
                {
                    code: '2000009', name: 'ΓΡΑΝΙΤΗΣ ΞΟΦΑΡΙ', assessments: [
                        'K',
                        'KΞ',
                        'VΞ'
                    ]
                }
            ],
            shelves: [
                'M0',
                'M01',
                'M02',
                'M03',
                'M04',
                'M05',
                'M1',
                'M2',
                'Μ3',
                'M4',
                'M5',
                'M6',
                'M7',
                'M8',
                'M9',
                'Δ',
                'ΥΜ6',
                'YM6-2',
                '2022'
            ]
        },
        {
            company: '003',
            name: 'Prilep',
            whCode: '79',
            ordersWhCode: '71',
            products: [
                {
                    code: '7000001',
                    name: 'POLARIS',
                    assessments: [
                        'P1',
                        'P2',
                        'P2-3',
                        'P3',
                        'P4',
                        'PA2',
                        'PA3',
                        'PW1',
                        'PW2',
                        'PW2-3',
                        'PW3',
                        'PW4',
                        'PWA',
                        'PT'
                    ],
                    firstAssessments: [
                        'PW',
                        'PE',
                        'PC',
                        'PT'
                    ]
                },
            ],
            shelves: [
                'BP1 920',
                'BP1 930',
                'BP1 940',
                'BP1 950',
                'BP1 960',
                'BP1 970',
                'BP1 980',
                'BP1 990',
                'BP2 838',
                'BP2 904',
                'BP2 908',
                'BP2 920',
                'LE1 832',
                'LE1 838',
                'LE1 846',
                'LE2 838',
                'LE2 842',
                'LE2 850',
                'LE2 832',
                'SK  992',
                'SK 1000',
                'SK 1006',
                'TU  788',
                'TU  796',
                'TU  802',
                'TU  808',
                'BV  934',
                'BV  940',
                'BV  946',
                'KR 1362',
                'KR 1370',
                'KR 1376'
            ]
        },
        {
            company: '001',
            name: 'Θήβα',
            whCode: '5',
            products: [
            ],
            shelves: [
            ]
        },
        {
            company: '007',
            name: 'ΔΙΟΝΥΣΟΣ',
            whCode: '219',
            ordersWhCode: '211',
            products: [
                {
                    code: '0000001',
                    name: 'ΟΓΚΟΣ ΜΑΡΜΑΡΟΥ ΔΙΟΝΥΣΟΥ',
                    draftCode: '0000001',
                    draftName: 'ΞΩΦΑΡΙ ΔΙΟΝΥΣΟΥ',
                    assessments: [
                        'D1',
                        'D2',
                        'D3',
                        'D4',
                        'G1',
                        'G2',
                        'AA',
                        'A',
                        'AB',
                        'B',
                        'BB',
                        'ΑΠ',
                        'T'
                    ],
                    colors: [
                        'Α',
                        'Β1',
                        'Β2',
                        'Γ1',
                        'Γ2',
                        'Δ1',
                        'Δ2',
                        'DM',
                        'D2',
                        'D',
                        'ΠΜ',
                        'Π2',
                        'Π',
                        'ΑΚ'
                    ],
                    problems: [
                        'Βίνα',
                        'Κομός',
                        'Κοκκάλλια',
                        'Σπαθιές',
                        'Αλατιά',
                        'Χαλαζίας',
                        'Πάρσιμο',
                        'Διατρήματα',
                        'Άνευ ελαττώματος'
                    ],
                    shapes: [
                        {
                            code: 'ΟΡΘΠ', name: 'ΟΡΘΟΓΩΝΙΟ ΠΑΡΑΛΛΗΛΕΠΙΠΕΔΟ'
                        },
                        {
                            code: 'ΠΡΛΠ', name: 'ΠΑΡΑΛΛΗΛΕΠΙΠΕΔΟ'
                        },
                        {
                            code: 'ΤΡΠΖ', name: 'ΤΡΑΠΕΖΟΕΙΔΕΣ'
                        },
                        {
                            code: 'ΞΦΡ', name: 'ΞΩΦΑΡΙ'
                        }
                    ]
                },
            ],
            shelves: [
                'B 03',
                'B 04',
                'B 05',
                'B 06',
                'B 06.1',
                'B 07',
                'B 07.1',
                'B 08',
                'B 09',
                'B 10',
                'B 10.1',
                'B 11',
                'B 12',
                'B 13',
                'B 14',
                'B 15',
                'B 16',
                'N 03',
                'N 04',
                'N 05',
                'N 06',
                'N 06.1',
                'N 07',
                'N 07.1',
                'N 08',
                'N 09',
                'N 10',
                'N 10.1',
                'N 11',
                'N 12',
                'N 13',
                'N 14',
                'N 15',
                'N 16',
                'ΑΕ',
                'ΤΡΙΒΕΙΟ',
                'ΠΑΛΙΟ ΤΡΙΒΕΙΟ'
            ]
        }
    ];

    constructor() {
        this.systemService = new SystemService();
        this.api = this.systemService.getApiAccess();
    }

    login(username, password) {
        let loginPromise = new Promise((resolve, reject) => {
            this.api.post('auth/login', { username, password }).then(r => {
                localStorage.setItem('nordia-app-user', JSON.stringify(r.data));
                const whsVal = r.data.user && r.data.user.whs;
                if(whsVal && whsVal.split(',').length === 1) {
                    let config = this.availableConfigs.find(c => c.whCode === whsVal);
                    localStorage.setItem('nordia-app-config', JSON.stringify(config));
                }
                window.dispatchEvent(new Event('authChanged'));
                resolve(r.data);
            }).catch(e => {
                reject('Αποτυχία Σύνδεσης. ελέγξτε ότι τα στοιχεία σας είναι σωστά.');
            })
        });
        return loginPromise;
    }

    logout() {
        localStorage.setItem('nordia-app-user', null);
        localStorage.setItem('nordia-app-config', null);
        window.dispatchEvent(new Event('authChanged'));
    }

    setUser(user) {
        try {
            let data = JSON.parse(localStorage.getItem('nordia-app-user'));
            if (data) {
                data.user = user;
                localStorage.setItem('nordia-app-user', JSON.stringify(data));
                window.dispatchEvent(new Event('authChanged'));
            }
        } catch (e) {
            console.error(e);
        }
    }

    refreshUserSession() {
        let sessionId = this.getSessionId();
        if (!sessionId) return Promise.resolve(null);
        return new Promise((resolve) => {
            this.api.get('auth', { headers: { authorization: sessionId } })
                .then(r => {
                    const u = r.data && (r.data.user || (r.data.userId ? r.data : null));
                    if (u) {
                        this.setUser(u);
                        resolve(u);
                    } else {
                        resolve(null);
                    }
                })
                .catch(() => {
                    this.api.get('auth/getSession', { headers: { authorization: sessionId } })
                        .then(r => {
                            const u = r.data && (r.data.user || (r.data.userId ? r.data : null));
                            if (u) {
                                this.setUser(u);
                                resolve(u);
                            } else {
                                resolve(null);
                            }
                        })
                        .catch(() => {
                            resolve(null);
                        });
                });
        });
    }

    getUser() {
        let user = false;
        try {
            user = JSON.parse(localStorage.getItem('nordia-app-user')).user;
        } catch (e) {
            return false;
        }
        if (user) {
            return user;
        }
        else {
            return false;
        }
    }

    getSessionId() {
        let sessionId = false;
        try {
            sessionId = JSON.parse(localStorage.getItem('nordia-app-user')).sessionId;
        } catch (e) {
            return false;
        }
        return sessionId;
    }

    getConfig() {
        let config = false;
        try {
            config = JSON.parse(localStorage.getItem('nordia-app-config'));
        } catch (e) {
            return false;
        }
        return config;
    }

    setConfig(config) {
        localStorage.setItem('nordia-app-config', JSON.stringify(config));
    }

    getAvailableConfigs() {
        try {
            let user = JSON.parse(localStorage.getItem('nordia-app-user'));
            return this.availableConfigs.filter(c => user.user.whs.split(',').includes(c.whCode))
        } catch (e) {
            return [];
        }
    }

    getValidShelves(){
        let config = this.getConfig();
        let selectedShelvesStorage = localStorage.getItem('nordia-app-selected-shelves');
        if(selectedShelvesStorage){
            return JSON.parse(selectedShelvesStorage);
        }
        else if(config){
            return config.shelves;
        }
        return [];
    }

    setValidShelves(shelves){
        localStorage.setItem('nordia-app-selected-shelves', JSON.stringify(shelves));
    }

}

export default AuthService;